export const AZURE_SUBSCRIPTION_ID_VALIDATION = {
  message:
    'Must be valid UUID format (a-f, numbers, hyphens, total of 36 characters)',
  // 36 character UUID. Example: ABC222aa-a2a2-aa22-2a2a-222aa2a2a2a
  regex: /^[A-F\d]{8}-[A-F\d]{4}-[A-F\d]{4}-[A-F\d]{4}-[A-F\d]{12}$/i
}

export const AZURE_SUBSCRIPTION_ID_DUPLICATION = {
  message: 'Cannot be an existing Subscription ID',
  // Checks against existing integrationIds (uppercased by consumer)
  test: (value: string | undefined, integrationIdsUppercase: Set<string>) =>
    !value ||
    integrationIdsUppercase.size === 0 ||
    !integrationIdsUppercase.has(value.toUpperCase())
}
